import { z } from "@hono/zod-openapi";
import { maybeOnVehicleRefs } from "../../refs";

/**
 * Vehicle-centric: the job's unit, which the vendor leaves unnamed on a small fraction of tasks.
 *
 * `completedByWorkspaceMembershipId` is the vendor-recorded actor — the membership the vendor says performed the
 * task, which is not the driver of record, since a manager may complete a call — and null for vendors that record no
 * actor at all. Inlined rather than promoted to a mixin: StopEvent is the only subject that carries it.
 */
export const stopEventRefs = { ...maybeOnVehicleRefs, completedByWorkspaceMembershipId: z.string().nullable() };

export type StopEventRefs = z.infer<z.ZodObject<typeof stopEventRefs>>;
